import React, { SyntheticEvent } from 'react';

import DeliveryTypeItem from '@r1-frontend/service-engineer-visit/components/DeliveryTypeItem';
import { TDeliveryOption } from '@r1-frontend/service-engineer-visit/types/TDeliveryOption';

import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Cost } from '@r1-frontend/ui-react/experimental/purchase/cost';

import * as S from './styled';

type TDeliveryOptionsProps = {
    deliveryOptions: TDeliveryOption[],
    selectedDeliveryOption?: TDeliveryOption,
    handleDeliveryOptionSelection: (option: TDeliveryOption) => (e: SyntheticEvent) => void,
    loading: boolean,
}

const DeliveryOptions = ({ deliveryOptions, selectedDeliveryOption, handleDeliveryOptionSelection, loading }: TDeliveryOptionsProps): JSX.Element => {
    return (
        <S.Block>
            <H4 $smaller>Настроить оборудование?</H4>

            <S.DeliveryOptionsWrapper>
                {deliveryOptions.map(option =>
                    <DeliveryTypeItem
                        key={`visitOptions_deliveryOption_${option.name}`}
                        onClick={handleDeliveryOptionSelection(option)}
                        $selected={selectedDeliveryOption?.name === option.name}
                        disabled={loading}
                    >
                        {option.label}
                        <Cost>{option.cost}</Cost>
                    </DeliveryTypeItem>)}
            </S.DeliveryOptionsWrapper>
        </S.Block>
    );
};

export default DeliveryOptions;
